import { Injectable, Injector } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Observable, EMPTY, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import * as GameSocketActions from './gameSocket.actions';
import { Store } from '@ngrx/store';
import { AppState } from '../app.state';
import { TableType } from '@soposopo/sopo-models';
import { GameServer } from '../../backend/game-server/base/game-server.class';
import { MttGameServer } from '../../backend/game-server/mtt-game-server.class';
import { RingGameServer } from '../../backend/game-server/ring-game-server.class';
import { SngGameServer } from '../../backend/game-server/sng-game-server.calss';
import { GameSocketStoreDispatcher } from './gameSocket.dispatcher';


@Injectable()
export class GameSocketEffects {

    constructor(
        private actions$: Actions,
        private store: Store < AppState > ,
        private injector: Injector,
        private gameSocketDispatcher: GameSocketStoreDispatcher
    ) {
    }


    createSocket$ = createEffect(() => this.actions$
        .pipe(
            ofType(GameSocketActions.createGameSocketAction),
            switchMap(action => {
                const gameServerAlreadyCreated = this.gameSocketDispatcher.isGameServerCreated(action.gameStateId);
                if (gameServerAlreadyCreated) return EMPTY;
                const url = action.url;
                const gameStateId = action.gameStateId;
                const gameType = action.gameType;
                let socket: GameServer;
                switch (gameType) {
                    case TableType.RING:
                        socket = new RingGameServer(url, gameStateId, this.injector);
                        break;
                    case TableType.SNG:
                        socket = new SngGameServer(url, gameStateId, this.injector);
                        break;
                    case TableType.MTT:
                        socket = new MttGameServer(url, gameStateId, this.injector);
                        break;
                }
                this.gameSocketDispatcher.newGameServer(socket, gameStateId);
                return of(GameSocketActions.gameSocketCreatedAction({gameStateId, gameServerId: gameStateId, url, gameType}))
            })
        ))


    reomveSocket$: Observable<void> = createEffect(() => this.actions$
        .pipe(
            ofType(GameSocketActions.removeGameSocket),
            map((action) => {
                const gameStateId = action.gameStateId;
                console.log('remove game server', gameStateId)
                this.gameSocketDispatcher.deleteGameServer(gameStateId);
            })
        ), {dispatch: false})

}
